// extracted by mini-css-extract-plugin
export default {"container":"loader_container__lBuF6"};